import React from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Modal, Button } from "antd";
import styles from "./PersonModals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";

type Props = {
  visible: boolean;
  setVisibility: Function;
};

function UnsavedChangesModal({ visible, setVisibility }: Props) {
  const { width } = useWindowSize();
  const history = useHistory();

  function handleClose() {
    setVisibility(false);
  }
  function handleYesCancel() {
    history.goBack();
  }

  return (
    <Modal
      visible={visible}
      className={styles.unsavedChangesModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "500px"}
      footer={
        <Row justify="center" gutter={[10, 15]}>
          <Col>
            <Button className={styles.cancel} onClick={handleClose}>
              Close
            </Button>
          </Col>
          <Col>
            <Button className={styles.yesCancel} onClick={handleYesCancel}>
              Yes, Cancel
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center" className={styles.title}>
        Unsaved Changes
      </Row>
      <Row justify="center">
        <Col className={styles.description}>
          Are you sure you want to cancel? Your unsaved changes will be lost.
        </Col>
      </Row>
    </Modal>
  );
}

export default UnsavedChangesModal;
